export default "__VITE_ASSET__$yxa$8yE__"